(function () {
    var MOBILE_BREAKPOINT = 768;
  
    function isMobile() {
      return typeof window !== 'undefined' && window.innerWidth <= MOBILE_BREAKPOINT;
    }
  
    function init() {
      if (typeof window.ADDON_POPUP === 'undefined' || !window.ADDON_POPUP.enabled || !window.ADDON_POPUP.products || window.ADDON_POPUP.products.length < 1) return;
  
      var formId = window.ADDON_POPUP.formId;
      var overlay = document.getElementById('addon-popup-overlay');
      var productsContainer = document.getElementById('addon-popup-products');
      var dotsContainer = document.getElementById('addon-popup-dots');
      var titleEl = document.getElementById('addon-popup-title');
      var subtitleEl = document.getElementById('addon-popup-subtitle');
  
      if (!overlay || !productsContainer || !formId) return;
  
      var form = document.getElementById(formId) || document.querySelector('form[id="' + formId + '"]:not([hidden])');
      if (!form || form.tagName !== 'FORM') return;
  
      var pendingForm = null;
      var pendingFormData = null;
      var currentSlide = 0;
      var totalSlides = 1;
      var atcText = 'ADD TO CART';
  
      function getOrderedProducts(arr, n) {
        return arr.slice(0, Math.min(n || 4, arr.length));
      }
  
      function makeCardHtml(p) {
        var vid = p.variant_id;
        var priceHtml = p.compare_at_price
          ? '<s class="addon-popup-card-compare igComparePrice" data-variant-id="' + vid + '">' + p.compare_at_price + '</s> <span class="addon-popup-card-current igPrice" data-variant-id="' + vid + '">' + (p.price || '') + '</span>'
          : (p.price || '');
        var btnLabel = atcText + (p.price ? ' – ' + priceHtml : '');
        return '<div class="addon-popup-card-image">' +
          (p.image ? '<img src="' + p.image + '" alt="" loading="eager" decoding="async">' : '') +
          '</div><div class="addon-popup-card-title">' + (p.title || '') + '</div>' +
          (p.value_text ? '<div class="addon-popup-card-value">' + p.value_text + '</div>' : '') +
          '<div class="addon-popup-card-price" style="display:none">' + (p.price || '') + '</div>' +
          '<button type="button" class="addon-popup-card-btn" data-addon-variant-id="' + p.variant_id + '">' + btnLabel + '</button>';
      }
  
      function buildSlides(products) {
        if (isMobile()) {
          return products.map(function (p) { return [p]; });
        }
        var slides = [];
        for (var i = 0; i < products.length; i += 2) {
          slides.push(products.slice(i, i + 2));
        }
        return slides;
      }
  
      function renderCards(slides) {
        productsContainer.innerHTML = '';
        productsContainer.style.width = slides.length * 100 + '%';
        var slideWidthPct = 100 / slides.length;
        slides.forEach(function (pair) {
          var slideEl = document.createElement('div');
          slideEl.className = 'addon-popup-slide';
          slideEl.style.flexBasis = slideWidthPct + '%';
          slideEl.style.maxWidth = slideWidthPct + '%';
          pair.forEach(function (p) {
            var card = document.createElement('div');
            card.className = 'addon-popup-card';
            card.innerHTML = makeCardHtml(p);
            slideEl.appendChild(card);
          });
          productsContainer.appendChild(slideEl);
        });
        dotsContainer.innerHTML = '';
        slides.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'addon-popup-dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Slide ' + (i + 1));
          dot.dataset.addonDot = i;
          dotsContainer.appendChild(dot);
        });
        var carousel = overlay.querySelector('.addon-popup-carousel');
        carousel.classList.toggle('addon-popup-carousel--single', slides.length <= 1);
      }
  
      function showSlide(index) {
        currentSlide = index;
        var offset = -index * (100 / totalSlides);
        productsContainer.style.transform = 'translateX(' + offset + '%)';
        var dots = overlay.querySelectorAll('.addon-popup-dot');
        for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === index);
      }
  
      function openPopup(form, products) {
        pendingForm = form;
        pendingFormData = new FormData(form);
        if (document.body.getAttribute('data-bundle-selector-ab') === 'true' && window.BundleSelectorAb) {
          window.BundleSelectorAb.refreshPending(form.getAttribute('id'));
        }
        var slides = buildSlides(products);
        if (slides.length === 0) return;
        totalSlides = slides.length;
        currentSlide = 0;
        if (titleEl) titleEl.textContent = window.ADDON_POPUP.title || '';
        if (subtitleEl && window.ADDON_POPUP.subtitle) subtitleEl.textContent = window.ADDON_POPUP.subtitle;
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(function () {
          renderCards(slides);
          showSlide(0);
        });
      }
  
      function closePopup() {
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
        pendingForm = null;
        pendingFormData = null;
      }
  
      function resolveBundleCartItems() {
        if (window.BundleSelectorAb && window.BUNDLE_SELECTOR_PENDING && window.BUNDLE_SELECTOR_PENDING.formId) {
          var liveItems = window.BundleSelectorAb.refreshPending(window.BUNDLE_SELECTOR_PENDING.formId);
          if (liveItems && liveItems.length > 0) {
            return liveItems.map(function (item) {
              return { id: parseInt(item.id, 10), quantity: item.quantity || 1 };
            });
          }
        }
        var targetFormId = pendingForm && pendingForm.getAttribute('id');
        if (window.BundleSelectorAb && targetFormId) {
          var formItems = window.BundleSelectorAb.refreshPending(targetFormId);
          if (formItems && formItems.length > 0) {
            return formItems.map(function (item) {
              return { id: parseInt(item.id, 10), quantity: item.quantity || 1 };
            });
          }
        }
        if (window.BUNDLE_SELECTOR_PENDING && window.BUNDLE_SELECTOR_PENDING.items && window.BUNDLE_SELECTOR_PENDING.items.length > 0) {
          return window.BUNDLE_SELECTOR_PENDING.items.map(function (item) {
            return { id: parseInt(item.id, 10), quantity: item.quantity || 1 };
          });
        }
        return null;
      }

      function addMainProductToCart(done) {
        var bundleItems = resolveBundleCartItems();
        if (bundleItems && bundleItems.length > 0) {
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
          var drawerEl = document.querySelector('cart-drawer');
          var sectionId = drawerEl && drawerEl.closest('.shopify-section') ? drawerEl.closest('.shopify-section').id.replace('shopify-section-', '') : '';
          var firstVid = bundleItems[0].id;

          fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({
              items: bundleItems,
              sections: sectionId ? sectionId : 'variant-added',
              sections_url: root + 'variants/' + firstVid
            })
          })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (data && !data.status) {
                var discountPromise = Promise.resolve();
                if (window.BundleSelectorAb && pendingForm) {
                  var discountCode = window.BundleSelectorAb.getDiscountCode(pendingForm.getAttribute('id'));
                  if (discountCode && typeof window.BundleSelectorAb.applyDiscountCode === 'function') {
                    discountPromise = window.BundleSelectorAb.applyDiscountCode(discountCode);
                  } else if (typeof window.BundleSelectorAb.clearBundleDiscount === 'function') {
                    discountPromise = window.BundleSelectorAb.clearBundleDiscount();
                  }
                }
                discountPromise.then(function () {
                if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === 'page') {
                  window.location.href = root + 'cart';
                  if (done) done();
                  return;
                }
                fetch(root + 'cart.js').then(function (res) { return res.json(); }).then(function (cartContent) {
                  if (data.sections) cartContent.sections = data.sections;
                  if (pendingForm) {
                    pendingForm.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: data.items || bundleItems, cart: cartContent } }));
                  }
                  document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cartContent } }));
                  if (done) done();
                }).catch(function () {
                  document.dispatchEvent(new CustomEvent('cart:refresh'));
                  if (done) done();
                });
                });
              } else {
                if (pendingForm) {
                  pendingForm.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: (data && data.description) || 'Error' } }));
                }
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                if (done) done();
              }
            })
            .catch(function () {
              if (done) done();
            })
            .finally(function () {
              window.BUNDLE_SELECTOR_PENDING = null;
            });
          return;
        }

        if (!pendingForm || !pendingFormData) {
          if (done) done();
          return;
        }
        var form = pendingForm;
        var formData = new FormData();
        pendingFormData.forEach(function (value, key) {
          formData.set(key, value);
        });
        var drawerEl = document.querySelector('cart-drawer');
        var sectionId = drawerEl && drawerEl.closest('.shopify-section') ? drawerEl.closest('.shopify-section').id.replace('shopify-section-', '') : '';
        var sectionsToRequest = ['variant-added'];
        if (sectionId) sectionsToRequest.push(sectionId);
        formData.set('sections', sectionsToRequest.join(','));
        var vid = form.querySelector('input[name="id"]') && form.querySelector('input[name="id"]').value;
        formData.set('sections_url', (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'variants/' + vid);
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && !data.status) {
              if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === 'page') {
                window.location.href = root + 'cart';
                if (done) done();
                return;
              }
              fetch(root + 'cart.js').then(function (res) { return res.json(); }).then(function (cartContent) {
                if (data.sections) cartContent.sections = data.sections;
                form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: data.items || [data], cart: cartContent } }));
                document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cartContent } }));
                if (done) done();
              }).catch(function () {
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                if (done) done();
              });
            } else {
              form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: (data && data.description) || 'Error' } }));
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              if (done) done();
            }
          })
          .catch(function () {
            if (done) done();
          });
      }
  
      function addVariantToCart(variantId, quantity, next) {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        var drawerEl = document.querySelector('cart-drawer');
        var sectionId = drawerEl && drawerEl.closest('.shopify-section') ? drawerEl.closest('.shopify-section').id.replace('shopify-section-', '') : '';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity || 1,
            sections: sectionId ? sectionId : 'variant-added',
            sections_url: root + 'variants/' + variantId
          })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && !data.status) {
              if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === 'page') {
                window.location.href = root + 'cart';
              } else if (data.sections && sectionId && data.sections[sectionId]) {
                fetch(root + 'cart.js').then(function (res) { return res.json(); }).then(function (cartContent) {
                  cartContent.sections = data.sections;
                  document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cartContent } }));
                }).catch(function () { document.dispatchEvent(new CustomEvent('cart:refresh')); });
              } else {
                document.dispatchEvent(new CustomEvent('cart:refresh'));
              }
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            }
            if (next) next();
          })
          .catch(function () { document.dispatchEvent(new CustomEvent('cart:refresh')); if (next) next(); });
      }
  
      function openDrawer() {
        var drawer = document.querySelector('cart-drawer, cart-notification-drawer');
        if (drawer && typeof drawer.show === 'function') {
          drawer.show();
        }
      }

      function finishCartFlow() {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        openDrawer();
      }

      function getCheckedAddonVariantIds() {
        var productId = window.ADDON_POPUP.productId;
        var formId = window.ADDON_POPUP.formId;
        var ids = [];
        var seen = {};
        function pushVid(el) {
          var vid = el.getAttribute('data-addon-variant-id');
          if (!vid) return;
          var n = parseInt(vid, 10);
          if (!seen[n]) {
            seen[n] = true;
            ids.push(n);
          }
        }
        document.querySelectorAll('input.product-addon__toggle[data-addon-variant-id]:checked').forEach(pushVid);
        var form = formId ? document.getElementById(formId) : null;
        var checkboxes = form ? form.querySelectorAll('input[data-addon-variant-id]:checked') : [];
        if (checkboxes.length === 0) {
          checkboxes = document.querySelectorAll('input[data-addon-variant-id]:checked');
        }
        checkboxes.forEach(pushVid);
        if (productId) {
          document.querySelectorAll('.addon-checkbox-' + productId + ':checked').forEach(pushVid);
        }
        return ids;
      }

      function addToggleVariantsToCart(variantIds, done) {
        if (!variantIds || variantIds.length === 0) {
          if (done) done();
          return;
        }
        if (variantIds.length === 1) {
          addVariantToCart(variantIds[0], 1, function () {
            resetCheckedAddonToggles();
            if (done) done();
          });
          return;
        }
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        var drawerEl = document.querySelector('cart-drawer');
        var sectionId = drawerEl && drawerEl.closest('.shopify-section') ? drawerEl.closest('.shopify-section').id.replace('shopify-section-', '') : '';
        var firstVid = variantIds[0];
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: variantIds.map(function (id) { return { id: id, quantity: 1 }; }),
            sections: sectionId ? sectionId : 'variant-added',
            sections_url: root + 'variants/' + firstVid
          })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && !data.status) {
              if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === 'page') {
                window.location.href = root + 'cart';
              } else if (data.sections && sectionId && data.sections[sectionId]) {
                fetch(root + 'cart.js').then(function (res) { return res.json(); }).then(function (cartContent) {
                  cartContent.sections = data.sections;
                  document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cartContent } }));
                }).catch(function () { document.dispatchEvent(new CustomEvent('cart:refresh')); });
              } else {
                document.dispatchEvent(new CustomEvent('cart:refresh'));
              }
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            }
            resetCheckedAddonToggles();
            if (done) done();
          })
          .catch(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            resetCheckedAddonToggles();
            if (done) done();
          });
      }

      function resetCheckedAddonToggles() {
        var productId = window.ADDON_POPUP.productId;
        var formId = window.ADDON_POPUP.formId;
        var form = formId ? document.getElementById(formId) : null;
        var checkboxes = form ? form.querySelectorAll('input[data-addon-variant-id]:checked') : [];
        if (checkboxes.length === 0) {
          checkboxes = document.querySelectorAll('input[data-addon-variant-id]:checked');
        }
        if (checkboxes.length === 0 && productId) {
          checkboxes = document.querySelectorAll('.addon-checkbox-' + productId + ':checked');
        }
        document.querySelectorAll('input.product-addon__toggle[data-addon-variant-id]:checked').forEach(function (el) {
          el.checked = false;
          var card = el.closest('.addon-card') || el.closest('.product-addon');
          if (card) card.classList.remove('is-selected');
        });
        checkboxes.forEach(function (el) {
          el.checked = false;
          var card = el.closest('.addon-card') || el.closest('.product-addon');
          if (card) card.classList.remove('is-selected');
        });
      }

      function onNoThanks() {
        var toggleIds = getCheckedAddonVariantIds();
        addMainProductToCart(function () {
          closePopup();
          addToggleVariantsToCart(toggleIds, function () {
            finishCartFlow();
          });
        });
      }
  
      function onAddToBag(variantId, btn) {
        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Adding...'; 
        }
        var toggleIds = getCheckedAddonVariantIds();
        addVariantToCart(variantId, 1, function () {
          addMainProductToCart(function () {
            addToggleVariantsToCart(toggleIds, function () {
              closePopup();
              if (btn) {
                btn.disabled = false;
                var p = window.ADDON_POPUP.products.find(function (x) { return x.variant_id === parseInt(btn.getAttribute('data-addon-variant-id'), 10); });
                var priceHtml = p && p.compare_at_price
                  ? '<s class="addon-popup-card-compare igComparePrice" data-variant-id="' + p.variant_id + '">' + p.compare_at_price + '</s> <span class="addon-popup-card-current igPrice" data-variant-id="' + p.variant_id + '">' + (p.price || '') + '</span>'
                  : (p && p.price ? p.price : atcText);
                btn.innerHTML = p && p.price ? atcText + ' – ' + priceHtml : atcText;
              }
              finishCartFlow();
            });
          });
        });
      }
  
      overlay.addEventListener('click', function (e) {
        if (e.target.closest('[data-addon-close]')) {
          e.preventDefault();
          onNoThanks();
        }
        if (e.target.closest('[data-addon-no-thanks]')) {
          e.preventDefault();
          onNoThanks();
        }
        if (e.target.closest('.addon-popup-card-btn')) {
          var btn = e.target.closest('.addon-popup-card-btn');
          var vid = btn.getAttribute('data-addon-variant-id');
          if (vid) {
            e.preventDefault();
            onAddToBag(parseInt(vid, 10), btn);
          }
        }
        if (e.target.closest('[data-addon-prev]')) {
          e.preventDefault();
          var next = (currentSlide - 1 + totalSlides) % totalSlides;
          showSlide(next);
        }
        if (e.target.closest('[data-addon-next]')) {
          e.preventDefault();
          var next = (currentSlide + 1) % totalSlides;
          showSlide(next);
        }
        if (e.target.closest('[data-addon-dot]')) {
          var dot = e.target.closest('[data-addon-dot]');
          var idx = parseInt(dot.dataset.addonDot, 10);
          if (!isNaN(idx)) showSlide(idx);
        }
      });
  
      function isAddonToggleChecked() {
        if (document.querySelector('input.product-addon__toggle[data-addon-variant-id]:checked')) return true;
        var form = document.getElementById(formId);
        var inForm = form ? form.querySelectorAll('input[data-addon-variant-id]:checked') : [];
        if (inForm.length > 0) return true;
        if (document.querySelectorAll('input[data-addon-variant-id]:checked').length > 0) return true;
        var pid = window.ADDON_POPUP.productId;
        return !!(pid && document.querySelector('.addon-checkbox-' + pid + ':checked'));
      }

      document.addEventListener('click', function (e) {
        if (isMobile()) return;
        if (document.body.getAttribute('data-bundle-selector-ab') === 'true') return;
        var btn = e.target.closest('button[type="submit"]');
        if (!btn) return;
        var targetForm = btn.form || (btn.getAttribute('form') && document.getElementById(btn.getAttribute('form')));
        if (!targetForm || targetForm.getAttribute('id') !== formId) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var products = getOrderedProducts(window.ADDON_POPUP.products, 4);
        if (products.length === 0) return;
        openPopup(targetForm, products);
      }, true);

      form.addEventListener('submit', function (e) {
        if (document.body.getAttribute('data-bundle-selector-ab') === 'true') return;
        if (isMobile()) {
          // Popup is hidden on small screens; still add main line + checked inline toggles (Enter / programmatic submit).
          if (!isAddonToggleChecked()) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          pendingForm = form;
          pendingFormData = new FormData(form);
          var toggleIds = getCheckedAddonVariantIds();
          var submitBtns = Array.from(form.elements).filter(function (b) { return b.type === 'submit'; });
          submitBtns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
          addMainProductToCart(function () {
            addToggleVariantsToCart(toggleIds, function () {
              submitBtns.forEach(function (b) { b.removeAttribute('aria-busy'); });
              finishCartFlow();
            });
          });
          return;
        }
        if (!window.ADDON_POPUP || !window.ADDON_POPUP.enabled || !window.ADDON_POPUP.products || window.ADDON_POPUP.products.length < 1) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var products = getOrderedProducts(window.ADDON_POPUP.products, 4);
        if (products.length === 0) return;
        openPopup(form, products);
      }, true);

      document.addEventListener('addon-popup:open', function (e) {
        if (isMobile()) return;
        var targetForm = (e.detail && e.detail.form) || document.getElementById(formId);
        if (!targetForm || targetForm.tagName !== 'FORM') return;
        if (document.body.getAttribute('data-bundle-selector-ab') === 'true' && window.BundleSelectorAb) {
          window.BundleSelectorAb.refreshPending(targetForm.getAttribute('id'));
        }
        var products = getOrderedProducts(window.ADDON_POPUP.products, 4);
        if (products.length === 0) return;
        e.preventDefault();
        e.stopPropagation();
        openPopup(targetForm, products);
      }, true);
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  